import axios from '@/plugins/axios'
import axiosExportApi from '@/plugins/axiosExport'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getAccountId = () => useAuthorizationStore().getAccountSlug
const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const deleteAccount = () => axios.delete(`${getAccountId()}`)
const getSettings = () => axios.get(`${getAccountId()}/settings`)
const updateSettings = (formData) => axios.patch(`${getAccountId()}/settings`, formData)
const updateSubscribe = (formData) => axios.patch(`${getAccountId()}/settings/email-subscribe`, formData)

const getPaymentHistory = (params) => axios.get(`${getWorkspaceId()}/billing-settings/payments`, { params })
const exportPaymentHistory = (params) => axiosExportApi.get(`export/${getWorkspaceId()}/payments`, { params, responseType: 'blob' })

const getPaymentAutoRecharge = () => axios.get(`${getWorkspaceId()}/billing-settings/payments/auto-recharge`)
const updatePaymentAutoRecharge = (formData) => axios.patch(`${getWorkspaceId()}/billing-settings/payments/auto-recharge`, formData)

const getPaymentFiltersAndSorting = () => axios.get(`${getWorkspaceId()}/payments/filters-and-sorting`)

export {
    deleteAccount,
    getSettings,
    updateSettings,
    getPaymentHistory,
    exportPaymentHistory,
    getPaymentAutoRecharge,
    updatePaymentAutoRecharge,
    getPaymentFiltersAndSorting,
    updateSubscribe,
}
